import React, { createContext, useState } from "react"


const Context = createContext();


const ContextData = ({ children }) => {
  const [Search, setSearch] = useState("")
  const [answer, setAnswer] = useState("")
  const [answersize, setAnswerSize] = useState()
  const [chatBitId, setChatBitId] = useState()
  const [similarQuestion, setSimilarQuestion] = useState([])
  const [pageSize, setPageSize] = useState("")
  const [topSearch, setTopSearch] = useState()
  const [loading,setLoading] = useState(false)
// const navigate = useNavigate()

  // let search = useParams();

  // useEffect(() => {

  //   const searchText = `${search.id}`
  //   getAnswer(searchText).then(res => {
  //     console.log(res)
  //     setAnswer(res.data.chatbot_response.response);
  //     setAnswerSize(res.data.chatbot_response.response.answer.length);
  //     setSimilarQuestion(res.data.chatbot_response.similar_response)
  //     setChatBitId(res.data.chatbot_response_id)
  //     sessionStorage.setItem("user_id", res.data.user_id)
  //   })
  // }, []);


  // const searchInside = (e) => {
  //   // e.preventDefault()
  //   return navigate(`/reponse/${topSearch}`)
  // }

  const showMore = (e) => {
    if (e.target.innerText == "...بیشتر") {
      e.target.parentNode.classList.remove("height-40")
      e.target.parentNode.classList.add("height-auto")
      e.target.previousSibling.classList.remove("answer-text-hight")
      e.target.previousSibling.classList.add("answer-text-hight-resize")
      e.target.previousSibling.classList.remove("hh")
      e.target.parentNode.children[0].style.display= "none"
      e.target.parentNode.children[1].style.display= "block"
      e.target.innerText = "بستن"
    } else {
      e.target.parentNode.classList.add("height-40")
      e.target.parentNode.classList.remove("height-auto")
      e.target.previousSibling.classList.add("answer-text-hight")
      e.target.previousSibling.classList.remove("answer-text-hight-resize")
      e.target.parentNode.children[0].style.display= "block"
      e.target.parentNode.children[1].style.display= "none"
      e.target.innerText = "...بیشتر"
    }
  }

  // useEffect(() => {

  //   // const show = document.querySelector(".for-more")

  //   window.addEventListener('resize', function (event) {
  //     setPageSize(window.innerWidth)
  //   })

  // }, [window.innerWidth]);

  // useEffect(() => {
  //   setPageSize(window.innerWidth)
  // }, [])

  const find = () => {
    let more = false
    // let survey = true
    const currentPageSize = pageSize
    let countWord = answersize

    // if(countWord < 150 && currentPageSize > 1500){
    //   more = true
    //   survey = false
    // } if(countWord < 130 && currentPageSize > 1200){
    //   more = true
    //   survey = false
    // }if(countWord < 100 && currentPageSize > 1000){
    //   more = true
    //   survey = false
    // }if(countWord < 70 && currentPageSize > 780){
    //   more = true
    //   survey = false
    // }if(countWord < 50 && currentPageSize > 550){
    //   more = true
    //   survey = false
    // }if(countWord < 30 ){
    //   more = true
    //   survey = true
    // }

    // if (countWord < 150 && currentPageSize > 1500) {
    //   more = false
    //   survey = true
    // } if (countWord < 140 && currentPageSize > 1400) {
    //   more = false
    //   survey = true
    // } if (countWord < 130 && currentPageSize > 1300) {
    //   more = false
    //   survey = true
    // }
    // if (countWord < 121 && currentPageSize > 1500) {
    //   more = false
    //   survey = true
    // }
    // if (countWord < 110 && currentPageSize > 1000) {
    //   more = true
    //   survey = false
    // }
    // if (countWord < 100 && currentPageSize > 1000) {
    //   more = true
    //   survey = false
    // } if (countWord < 70 && currentPageSize > 780) {
    //   more = true
    //   survey = false
    // } if (countWord < 50 && currentPageSize > 550) {
    //   more = true
    //   survey = false
    // } if (countWord < 30) {
    //   more = true
    //   survey = true
    // }

    // return [more, survey]
    if(countWord > 157 ){
      more = false
    }
    if(countWord > 110 && currentPageSize < 1199){
      more = false
    }
    if(countWord < 130 && currentPageSize > 1200){
      more = true
    }

    return [more]

  }
  const findSimilar = (length) => {
    let more = true
    // let survey = true
    const currentPageSize = pageSize
    let similarSize = length

    // console.log(similarSize,currentPageSize);

    // if (similarSize < 150 && currentPageSize > 1500) {
    //   more = false
    //   survey = true
    // } if (similarSize < 140 && currentPageSize > 1400) {
    //   more = false
    //   survey = true
    // } if (similarSize < 130 && currentPageSize > 1300) {
    //   more = false
    //   survey = true
    // }
    // if (similarSize < 121 && currentPageSize > 1500) {
    //   more = false
    //   survey = true
    // }
    // if (similarSize < 110 && currentPageSize > 1000) {
    //   more = true
    //   survey = false
    // }
    // if (similarSize < 100 && currentPageSize > 1000) {
    //   more = true
    //   survey = false
    // } if (similarSize < 70 && currentPageSize > 780) {
    //   more = true
    //   survey = false
    // } if (similarSize < 50 && currentPageSize > 550) {
    //   more = true
    //   survey = false
    // } if (similarSize < 30) {
    //   more = true
    //   survey = true
    // }
    if(similarSize > 150 ){
      more = false
    }
    if(similarSize > 110 && currentPageSize < 1199){
      more = false
    }
    if(similarSize < 130 && currentPageSize > 1200){
      more = true
    }
    
    return [more]

  }


  return <Context.Provider value={{
    answer,
    similarQuestion,
    showMore,
    find,
    findSimilar,
    setTopSearch,
    setPageSize,
    topSearch,
    setSearch,
    Search,
    setAnswer,
    setAnswerSize,
    setSimilarQuestion,
    setChatBitId,
    loading,
    setLoading
  }} >
    {children}
  </Context.Provider >


}

export { ContextData, Context }